import styled, { css } from 'styled-components';
import { media, layout } from 'src/components/base';

export const Placeholder = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;

  @keyframes gradient {
    0% {
      background-position: 100% 50%;
    }
    100% {
      background-position: -100% 50%;
    }
  }
`;

type DealProps = {
  mode: 'row' | 'grid';
  height: string | number;
};

export const Deal = styled.span<DealProps>`
  height: ${props => props.height};
  display: flex;
  flex-direction: column;
  padding: 20px;
  flex-grow: 1;
  min-width: 200px;

  ${media.smallOnly`
    min-width: 146px;
  `}
  ${props =>
    props.mode === 'grid' &&
    css`
      justify-content: space-between;
      padding-bottom: 10%;
    `}

    ${props =>
    props.mode === 'row' &&
    css`
      max-height: 88px;
      flex-direction: row;
      flex-wrap: nowrap;
    `}
`;

type MediaProps = {
  mediaPosition: number;
  mode: 'row' | 'grid';
};

export const Media = styled.span<MediaProps>`
  order: ${props => props.mediaPosition};
  display: flex;
  height: 50px;
  width: 50px;
  background: #eee;
  border-radius: ${layout.borderRadius};

  ${props =>
    props.mode === 'grid' &&
    css`
      align-self: center;
      height: 100px;
      width: 100px;
      margin-bottom: 10px;
    `}
`;

type RowsProps = {
  mode: 'row' | 'grid';
};

export const Rows = styled.div<RowsProps>`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${props =>
    props.mode === 'row' &&
    css`
      margin-left: 12px;
    `}

  ${props =>
    props.mode === 'grid' &&
    css`
      margin-top: 20px;
    `}
`;

type TextProps = {
  rowIndex?: number;
  mode: 'row' | 'grid';
};

export const Text = styled.span<TextProps>`
  ${props =>
    props.mode === 'grid' &&
    css`
      order: ${props.rowIndex && props.rowIndex + 1};
    `}
  display: flex;
  height: 10px;
  margin: 5px 0;
  width: 100%;
  background: linear-gradient(
    to right,
    rgba(238, 238, 238, 1) 8%,
    rgba(238, 238, 238, 0.5) 18%,
    rgba(238, 238, 238, 1) 33%
  );
  background-size: 300% 300%;
  animation: gradient 1s linear infinite;
  border-radius: 30px;

  &:nth-of-type(even) {
    width: 80%;
  }
`;
